import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { TruncatePipe } from './truncate.pipe';
import { DateAgoPipe } from './date-ago.pipe';
import { CustomCurrencyPipe } from './custome-currency.pipe';
import { PaymentMethodPipe } from '@shared/pipes/paymentMethod.pipe';
import { UTCToLocalTime } from './utc-to-localtime.pipe';
import { UnitOperatorPipe } from './operator.pipe';
import { PercentagePipe } from './percentage.pipe';



@NgModule({
    declarations: [
        TruncatePipe,
        DateAgoPipe,
        CustomCurrencyPipe,
        PaymentMethodPipe,
        UTCToLocalTime,
        UnitOperatorPipe,
        PercentagePipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TruncatePipe,
        DateAgoPipe,
        CustomCurrencyPipe,
        PaymentMethodPipe,
        UnitOperatorPipe,
        UTCToLocalTime,
        PercentagePipe
    ],
    providers: [CurrencyPipe]
})
export class PipesModule { }
